import { EDUCATION } from "../../data/portfolioData";
import { GradCapIcon, StarIcon } from "../ui/Icons";
import MovingBorder from "../ui/MovingBorder";
import Reveal from "../ui/Reveal";

// Same card treatment as Experience: logo tile on the left, details on the right.
const DURATIONS = [15000, 19000];

const Education = () => (
  <section id="education" className="py-20 w-full">
    <Reveal>
      <h2 className="heading">
        My <span className="text-accent">Education</span>
      </h2>
    </Reveal>
    <div className="w-full mt-12 grid lg:grid-cols-2 grid-cols-1 gap-10">
      {EDUCATION.map((item, i) => (
        <Reveal key={item.degree} delay={(i % 2) * 0.1} className="h-full">
          <MovingBorder duration={DURATIONS[i % DURATIONS.length]} className="h-full">
            <div className="flex md:flex-row flex-col md:items-center gap-6 md:gap-8 p-6 md:p-8 lg:p-10 h-full">
              <div className="w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 shrink-0 rounded-2xl bg-white overflow-hidden flex items-center justify-center p-2 shadow-[0_10px_24px_rgb(0_0_0/0.10)]">
                {item.logo ? (
                  <img src={item.logo} alt={item.institution} className="w-full h-full object-contain" />
                ) : (
                  <GradCapIcon size={48} className="text-accent" />
                )}
              </div>
              <div>
                <h3 className="text-start text-xl md:text-2xl font-bold leading-snug">{item.degree}</h3>
                <p className="text-start text-accent text-sm mt-1">
                  {item.institution} · {item.dates}
                </p>
                <p className="text-start text-ink/75 mt-3 text-sm leading-relaxed">{item.location}</p>
                <div className="flex flex-wrap gap-2 mt-4">
                  <span className="inline-flex items-center gap-1.5 rounded-full border border-ink/10 bg-primary/60 px-2.5 py-1 text-xs text-ink/75">
                    <StarIcon size={12} className="text-accent" />
                    {item.score}
                  </span>
                  <span className="inline-flex items-center rounded-full border border-ink/10 bg-primary/60 px-2.5 py-1 text-xs text-ink/75">
                    {item.tag}
                  </span>
                </div>
              </div>
            </div>
          </MovingBorder>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Education;
